import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Button from 'react-bootstrap/Button';
import Carousel from 'react-bootstrap/Carousel';
import slide1Img from '../../assets/slide1.jpg';
import slide2Img from '../../assets/slide2.jpg';
import slide3Img from '../../assets/slide3.jpg'; // Carefull, this one's a PNG
import Link from 'react-router-dom/Link';

export class ForUsersPage extends Component {
  render() {
    return (
      <div className="container">
        <Card>
          <Card.Header as="h3">
            Softie Pals for <i>Users</i>
          </Card.Header>
          <Card.Body>
            We all know that feeling when we're desparately looking for some
            software product (whether it's a game or an app or whatever) that
            needs to handle a specific task, but just can't find it.
          </Card.Body>
          <Card.Body>
            And even if we find it, a lot of problems still plague us:
            <ul>
              <li> Can I trust this product?</li>
              <li>
                {' '}
                I can't find any reviews -- what if I download it and it doesn't
                work?{' '}
              </li>
              <li> What will I do if I have a question? </li>
            </ul>
          </Card.Body>

          <Card.Body>
            <h5>
              <i>That's where Softie Pals comes in</i>
            </h5>
            There are developers out there who have built great products, but
            just can't be found as they do not have the resources to spend on
            growing, marketing, and appearing high in search results. We aim to
            fix just that by uniting both users and developers on this common
            platform.
          </Card.Body>
        </Card>
        <br />
        <Carousel
          style={{
            padding: '20px',
          }}
        >
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide1Img}
              height="600px"
              alt="First slide"
            />
            <Carousel.Caption>
              <h3>Simple searching</h3>
              <p>
                Each product defines its custom category of what it does. Thus,
                you can easily find all the products that match what you want
                them to do!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide2Img}
              height="600px"
              alt="Second slide"
            />

            <Carousel.Caption style={{ color: '#000000' }}>
              <h3>Strong Review System</h3>
              <p>
                Browse reviews created in our innovative objective+subjective
                system: the review scores are generated based on objective
                parameters to provide you an accurate assesment of the product!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={slide3Img}
              height="600px"
              alt="Third slide"
            />
            <Carousel.Caption>
              <h3>QA: Question and Answer</h3>
              <p>
                Got a question? Know an answer? Post on each product's dedicated
                QA page!{' '}
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>
        <br />
        <Jumbotron>
          <h1>Sounds exciting?</h1>
          <p>
            As part of our commitment to serving the community and making the
            platform open to everyone, the platform is free to use for everyone!
          </p>
          <p>
            <Button variant="outline-primary">
              <Link to="/signup">Get started now</Link>
            </Button>
          </p>
        </Jumbotron>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default ForUsersPage;
